import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const CirculationStatus = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Circulation Status</InputLabel>
      <Select
        value={moduleValues?.['Circulation Status'] ?? ''}
        label='Circulation Status'
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Circulation Status']: e.target.value,
          }))
        }
      >
        {['Normal', 'Reduced', 'Absent'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default CirculationStatus
